// extracted by mini-css-extract-plugin
export default {"container":"SlideContainer_container__ltnMT","title":"SlideContainer_title__0hTQ-","task_container":"SlideContainer_task_container__Tbmxl"};